import React from 'react'
import styles from './Style.module.css'

export const BtnPrimary = ({
  label,
  handleClick,
  disabled,
  customClass,
  varient,
  noIcon = false,
  nativeDisabled = false,
}) => {
  const handleButtonClick = (e) => {
    if (handleClick) {
      handleClick(e);
    }
  };

  return (
    <button className={`
    ${styles.BtnPrimary} 
    btn 
 ${noIcon ? '' : 'icn angle'}

    ${customClass}
    ${varient === 'danger' ? styles.danger : ""}
    ${disabled ? styles.disabled : ""}
    `}
    onClick={handleButtonClick}
    disabled={nativeDisabled && disabled}
    style={
      !nativeDisabled && disabled
        ? { pointerEvents: 'auto', opacity: 0.6 }
        : {}
    }
    aria-disabled={disabled}
    title={label}
    >
      {label}
    </button>
  )
}
